// src/components/EnquiryPopup.js
import React, { useState } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

const EnquiryPopup = ({ itemData }) => {
  const [formData, setFormData] = useState({ proname: "", proemail: "", promobile: "", promessage: "", prosku: itemData.SKU, proproduct: itemData.Name });
  const [response, setResponse] = useState(null);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
            setResponse(null);
        try {
          const res = await fetch('/api/product-enquiry.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          });
          const result = await res.json();
          setResponse(result.message); 
          //alert("Thank you for your enquiry!");
          setTimeout(() => {
            setResponse('');
            }, 3000);
        } catch (error) {
          console.error('Error:', error);
          alert("Error: "+error);
        }
  };


  return (
    <Popup trigger={<button className="theme-btn style-two">Send Enquiry</button>} modal nested>
      {(close) => (
        <div style={{padding: "20px"}}>
          <h4>Product Enquiry</h4>
          <p><b>Product: </b>{itemData.Name}</p>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="proname"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="proemail"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="promobile"
              placeholder="Your Mobile"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
            <textarea
              name="promessage"
              rows="4"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <span className="px-1"><button className="theme-btn style-two" type="submit">Submit</button></span>
            <span className="px-1"><button className="theme-btn style-four" type="button" onClick={close}>Close</button></span>
          </form>
          {response && <div className='alert alert-info'>{response}</div>}
        </div>
      )}
    </Popup>
  );
};

export default EnquiryPopup;